import { createContext, useContext } from 'react';

import { httpClient } from '../../httpClient';

export const HttpClientContext = createContext(httpClient);
export const useHttpClient = () => useContext(HttpClientContext);
